import fetchClient from "api/client";
import CAMPAIGNS_ENDPOINT from "./campaignsEndpoint";
/**
 * @description GET api/campaigns/:campaignId/rules
 * */
export default function getPhaseRules({ queryKey: [, { campaignId }], signal }) {
  if (!campaignId) {
    return Promise.reject(new Error("Campaign ID is required."));
  }

  const url = `${CAMPAIGNS_ENDPOINT}/${campaignId}/rules`;

  return fetchClient.get(url, { signal });
}
